import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const setMutedTagsWidgetBlacklistedTags = createAction(
  `${reduxKey}.SET_MUTEDTAGS_WIDGET_BLACKLISTED_TAGS`,
  (blacklistedTags: { name: string }[]) => ({ blacklistedTags })
);

export const saveMutedTags = createAction(
  `${reduxKey}.SAVE_MUTED_TAGS`,
  () => ({})
);

export const saveMutedTagsSuccess = createAction(
  `${reduxKey}.SAVE_MUTED_TAGS_SUCCESS`,
  () => ({})
);

export const saveMutedTagsFailure = createAction(
  `${reduxKey}.SAVE_MUTED_TAGS_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);
